
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26.25 26.25","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.25 1.465A1.378 1.378 0 0025.811.41 1.455 1.455 0 0024.786 0H1.465A1.428 1.428 0 00.41.41 1.428 1.428 0 000 1.465v23.32a1.456 1.456 0 00.41 1.025 1.378 1.378 0 001.055.439h12.539V16.055h-3.4v-3.926h3.4v-2.93a5.106 5.106 0 011.406-3.867 5.113 5.113 0 013.691-1.348q1.816 0 3.047.117v3.574h-2.109a2.031 2.031 0 00-1.582.527 2.178 2.178 0 00-.352 1.406v2.52h3.926l-.527 3.927h-3.399v10.2h6.68a1.378 1.378 0 001.055-.439 1.456 1.456 0 00.41-1.031z","data-name":"Path 141"}})])
          )
        }
      }
    